<div *ngIf="boxShow" class="fixed-box fixed left-0 bottom-0 full-width z-index-600 light-2" [ngClass]="[bgColor]" [@isShow]="boxShow">
  <div class="content-wrap full-height flex row wrap y-items-center">
    <div class="full-width">
      <div class="fixed-box-jackpot">
        <h3 class="flex row wrap y-items-center uppercase relative-left">
          <figure class="relative-left top--50p margin-right-10">
           <app-logo-lotto></app-logo-lotto>
          </figure>
          <span class="fb-jackpot-wrap block relative-left txt-left">
            <span class="fb-jackpot">
              <app-jackpot></app-jackpot>
            </span>
            <span class="fb-name block"> {{name}}<span class="inline-block fb-country margin-left-5">{{country}}</span> </span>
          </span>
        </h3>
      </div>
      <div class="fixed-box-play relative-right">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
  <div class="fixed-box-arrow-wrap absolute top--20 left-0 full-width">
    <div class="fixed-box-arrow absolute top-0 left-50p"></div>
  </div>
</div>
